if (!customElements.get('cart-gift-bag')) {
  customElements.define(
    'cart-gift-bag',
    class CartGiftBag extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('[data-gift-bag-checkbox]');
        this.checkbox.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'cart-gift-bag' || !event.cartData || !event.cartData.items) return;
          this.syncFromItems(event.cartData.items);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      get variantId() {
        return parseInt(this.dataset.variantId, 10);
      }

      syncFromItems(items) {
        const line = items.find((item) => item.variant_id === this.variantId);
        this.checkbox.checked = Boolean(line);
        this.dataset.lineKey = line ? line.key : '';
      }

      pageSections() {
        const sections = [];
        const cartItemsEl = document.getElementById('main-cart-items');
        const cartFooterEl = document.getElementById('main-cart-footer');

        if (cartItemsEl) {
          sections.push({ id: 'main-cart-items', section: cartItemsEl.dataset.id, selector: '.js-contents' });
        }
        if (cartFooterEl) {
          sections.push({ id: 'main-cart-footer', section: cartFooterEl.dataset.id, selector: '.js-contents' });
        }
        sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });

        return sections;
      }

      onChange(event) {
        const checked = event.target.checked;
        const cartDrawer = this.closest('cart-drawer');
        const pageSections = this.pageSections();
        const drawerSectionIds = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];
        const sections = [...new Set([...drawerSectionIds, ...pageSections.map((section) => section.section)])];

        this.checkbox.disabled = true;
        this.classList.add('loading');

        const request = checked
          ? fetch(routes.cart_add_url, {
              ...fetchConfig(),
              body: JSON.stringify({
                id: this.variantId,
                quantity: 1,
                sections,
                sections_url: window.location.pathname,
              }),
            })
          : fetch(routes.cart_change_url, {
              ...fetchConfig(),
              body: JSON.stringify({
                id: this.dataset.lineKey,
                quantity: 0,
                sections,
                sections_url: window.location.pathname,
              }),
            });

        request
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.errors || parsedState.status) {
              this.checkbox.checked = !checked;
              const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              if (errors) errors.textContent = parsedState.errors || parsedState.message;
              return;
            }

            if (checked) {
              // /cart/add.js responds with the added line item, not the full cart, so there's no .items to search.
              this.checkbox.checked = true;
              this.dataset.lineKey = parsedState.key;
            } else {
              // /cart/change.js responds with the full cart, so confirm removal against .items.
              this.syncFromItems(parsedState.items);
            }

            if (cartDrawer) cartDrawer.renderContents(parsedState);

            pageSections.forEach((section) => {
              const html = parsedState.sections[section.section];
              if (!html) return;
              const sourceElement = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
              const targetElement =
                document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
              if (sourceElement && targetElement) targetElement.innerHTML = sourceElement.innerHTML;
            });

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-gift-bag',
              cartData: parsedState,
              variantId: this.variantId,
            });
          })
          .catch((e) => {
            console.error(e);
            this.checkbox.checked = !checked;
          })
          .finally(() => {
            this.checkbox.disabled = false;
            this.classList.remove('loading');
          });
      }
    }
  );
}
